import { Paper } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomEmptyView from "../../../Components/CustomEmptyView";
import PaginationComponent from "../../../Components/CustomPagination";
import TableTopView from "../../../Components/TableTopView";
import Strings from "../../../Config/Strings";
import { deleteProductMetalPurityDetailsAPI } from "../../../Store/Action/productPurityAction";
import ProductPurityTableBody from "./Controls/ProductPurityTableBody";
import ProductPurityTableHeader from "./Controls/ProductPurityTableHeader";
import DeleteConfirmationPopup from "../../../Components/DeleteConfirmationPopup";
import Colors from "../../../theme/Colors";
import Pagination from "../../../Components/Pagination";

const PurityModuleTable = ({
  purityDetailData,
  rowsPerPage,
  handleChangePage,
  totalItems,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [modalVisible, setModalVisible] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productPurityIdToDelete, setProductPurityIdToDelete] = useState(null);

  const handleOpen = useCallback(() => setModalVisible(true), []);
  const handleClose = useCallback(() => setModalVisible(false), []);
  const handleCancelDelete = useCallback(() => setShowDeleteModal(false), []);
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total pages based on totalItems and rowsPerPage
  const totalPages = Math.ceil(totalItems / rowsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    handleChangePage(null, newPage - 1); // Adjusting index as per 0-based index system
  };

  const onViewProductPurityDetails = useCallback(
    (prodPurityId) =>
      navigate(`/productPurity/${prodPurityId?.id}`, {
        state: { prodPurityId },
      }),
    [navigate]
  );

  const onEditProductPurityDetails = useCallback(
    (editProdPurityData) =>
      navigate(`/productPurity/edit`, { state: { editProdPurityData } }),
    [navigate]
  );

  const handleShowDeleteModal = useCallback((productId) => {
    setProductPurityIdToDelete(productId);
    setShowDeleteModal(true);
  }, []);

  const handleDeleteUser = async () => {
    try {
      await dispatch(
        deleteProductMetalPurityDetailsAPI(
          productPurityIdToDelete,
          (isSuccess, response) => {
            setShowDeleteModal(false);
            if (isSuccess?.status === true) {
              toast.success(response?.data?.message);
              setTimeout(() => {
                window.location.reload();
              }, 400);
            } else {
              const errorMessage =
                response?.error?.message || Strings.somethingWentWrongError;
              toast.error(errorMessage);
            }
          }
        )
      );
    } catch (error) {
      console.log(
        "Error dispatching deleteProductMetalPurityDetailsAPI:",
        error
      );
      toast.error(Strings.somethingWentWrongError);
    }
  };

  return (
    <div style={mainContainer}>
      <div style={outerWrapper}>
        <div style={tableWrapper}>
          <div style={{ height: "92%", minWidth: "110%" }}>
            {purityDetailData?.length === 0 ||
            purityDetailData?.length === undefined ||
            purityDetailData?.length === null ? (
              <div style={{ width: "70vw" }}>
                <CustomEmptyView />
              </div>
            ) : (
              <>
                <table style={table}>
                  <ProductPurityTableHeader />
                  <ProductPurityTableBody
                    purityModDetails={purityDetailData}
                    onViewProductPurityDetails={onViewProductPurityDetails}
                    onEditProductPurityDetails={onEditProductPurityDetails}
                    handleShowDeleteModal={handleShowDeleteModal}
                  />
                </table>
              </>
            )}
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

const mainContainer = {
  borderRadius: "10px",
  height: "78%",
  marginTop: "25px",
  marginLeft: "24px",
  width: "96%",
};

const outerWrapper = {
  borderRadius: "4px",
  boxShadow: "0px 0px 3px #e6e6e6",
  maxWidth: "100%",
  height: "100%",
  backgroundColor: Colors.white,
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
};

const tableWrapper = {
  overflowY: "scroll",
  overflowX: "hidden",
  height: "100%",
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
};

const table = {
  minWidth: "100%",
  borderCollapse: "separate",
  borderSpacing: "0px",
};

export default PurityModuleTable;
